/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/**
=========================================================
* Material Dashboard 2 React - Payment Management
=========================================================
*/

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useState } from "react";
import usePayment from "hooks/usePayment";
import {
  Avatar,
  AvatarGroup,
  Chip,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import formatRupee from "../../../utils/formatHelper.js";
const formatDateIndian = (isoString) => {
  const date = new Date(isoString);

  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true, // Ensures AM/PM format
  });
};

export default function data() {
  const { paymentList } = usePayment();
  const [data, setData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState(null);

  const openDialogHandler = (payment) => {
    setSelectedPayment(payment);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedPayment(null);
  };

  const PaymentActions = ({ onPreview }) => (
    <MDBox display="flex" justifyContent="center">
      <MDButton variant="contained" color="info" sx={{ mr: 1 }} onClick={onPreview}>
        Preview
      </MDButton>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="lg"
        fullWidth
        BackdropProps={{
          style: { backgroundColor: "hsla(0, 0.00%, 0.00%, 0.12)" }, // Light transparent background
        }}
      >
        <DialogTitle>
          {selectedPayment?.name}
          <IconButton onClick={handleClose} sx={{ position: "absolute", right: 10, top: 10 }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <MDBox
              sx={{
                bgcolor: "grey.100",
                p: 2,
                borderRadius: 2,
                mb: 2,
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <MDTypography variant="subtitle1" fontWeight="bold">
                Total Quantity:
              </MDTypography>
              <MDTypography variant="h6" fontWeight="bold">
                {selectedPayment?.total}
              </MDTypography>
            </MDBox>

            <MDTypography variant="h6" gutterBottom>
              Distribution Details
            </MDTypography>

            {selectedPayment?.distributers.map((dist, index) => (
              <MDBox key={index} sx={{ border: 1, borderRadius: 2, overflow: "hidden", mb: 2 }}>
                <MDBox sx={{ bgcolor: "grey.200", p: 2, borderBottom: 1 }}>
                  <MDBox
                    sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
                  >
                    <MDTypography variant="subtitle1">{dist.distributer}</MDTypography>
                    <Chip label={`Total: ${dist?.total_quantity}`} color="primary" />
                  </MDBox>
                </MDBox>

                <MDBox sx={{ p: 2 }}>
                  <MDTypography variant="body2" color="textSecondary" gutterBottom>
                    Warehouses
                  </MDTypography>
                  <List>
                    {dist.warehouses.map((wh, widx) => (
                      <ListItem key={widx} sx={{ bgcolor: "grey.100", borderRadius: 1, mb: 1 }}>
                        <ListItemText primary={wh.warehouse} />
                        <MDTypography fontWeight="medium">{wh.quantity}</MDTypography>
                      </ListItem>
                    ))}
                  </List>
                </MDBox>
              </MDBox>
            ))}
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </MDBox>
  );

  const PaymentInfo = ({ name }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDTypography display="block" variant="button" fontWeight="medium">
        {name}
      </MDTypography>
    </MDBox>
  );

  const rows = data.map((payment) => ({
    dealer: <PaymentInfo name={payment?.dealer} />,
    distributor: payment.distributer,
    gstNo: payment.gstNo,
    outstanding: formatRupee(payment.outstanding),
    overdue: formatRupee(payment.overdue),
    territory: payment.territory,
    lastsynced: formatDateIndian(payment?.updatedAt),
    // actions: <PaymentActions onPreview={() => openDialogHandler(payment)} />,
  }));

  // Commented out as requested
  useEffect(() => {
    if (paymentList.products) {
      setData(paymentList.products);
    }
  }, [paymentList]);

  return {
    columns: [
      { Header: "Dealer", accessor: "dealer", width: "20%", align: "left" },
      { Header: "Distributor", accessor: "distributor", align: "center" },
      { Header: "GST No", accessor: "gstNo", align: "center" },
      { Header: "Out standing", accessor: "outstanding", align: "center" },
      { Header: "Over Due", accessor: "overdue", align: "center" },
      { Header: "Territory", accessor: "territory", align: "center" },
      { Header: "Last Synced", accessor: "lastsynced", align: "center" },
      // { Header: "Actions", accessor: "actions", align: "center" },
    ],
    rows,
  };
}
